(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-live"] && !Shopify.designMode) return;
  try {
    
  // Live opening queue: re-render the section (Section Rendering API) and swap the queue + "now opening" bar.
  (() => {
    if (window.plQueuePollInit) return;
    window.plQueuePollInit = true;
    const SWAP = ['[data-pl-queue]', '[data-pl-now]'];
    const refresh = (root) => {
      const url =
        window.location.pathname + '?section_id=' + encodeURIComponent(root.dataset.sectionId) + '&_=' + Date.now();
      return fetch(url, { headers: { Accept: 'text/html' } })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          SWAP.forEach((sel) => {
            const fresh = doc.querySelector(sel);
            const current = root.querySelector(sel);
            if (fresh && current && fresh.innerHTML !== current.innerHTML) current.innerHTML = fresh.innerHTML;
          });
        })
        .catch(() => {});
    };
    const tick = () => {
      if (document.hidden) return;
      document.querySelectorAll('[data-pl-queue-poll]').forEach(refresh);
    };
    const schedule = () => {
      const root = document.querySelector('[data-pl-queue-poll]');
      if (!root) return;
      const seconds = Math.max(10, parseInt(root.dataset.plQueuePoll, 10) || 30);
      setInterval(tick, seconds * 1000);
    };
    document.addEventListener('visibilitychange', tick);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
    else schedule();
  })();

  if (!customElements.get('pl-twitch-player')) {
    customElements.define(
      'pl-twitch-player',
      class PlTwitchPlayer extends HTMLElement {
        connectedCallback() {
          this.facade = this.querySelector('.pl-live__facade');
          if (!this.facade) return;
          if (this.hasAttribute('data-autoload')) {
            // Load and play on page open (muted setting keeps browser autoplay policies happy).
            this.load(true);
            return;
          }
          this.facade.addEventListener('click', () => this.load(true), { once: true });
        }
        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
        load(autoplay) {
          if (this.loaded) return;
          this.loaded = true;
          const iframe = document.createElement('iframe');
          // Twitch only plays when `parent` matches the page's real hostname (custom domain, preview, localhost).
          let src = this.dataset.src;
          const host = window.location.hostname;
          if (host && !src.includes('parent=' + host)) src += '&parent=' + encodeURIComponent(host);
          iframe.src = src + (autoplay ? '&autoplay=true' : '&autoplay=false');
          iframe.title = this.facade.getAttribute('aria-label') || 'Twitch';
          iframe.allowFullscreen = true;
          iframe.setAttribute('allow', 'autoplay; fullscreen');
          this.facade.replaceWith(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-packs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ARROW_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
    var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';

    function activePanel(root) {
      return root.querySelector('[data-pl-panel]:not([hidden])');
    }

    function pageList(current, total) {
      if (total <= 7) return Array.from({ length: total }, function (_, i) { return i + 1; });
      var pages = [1];
      var start = Math.max(2, current - 1);
      var end = Math.min(total - 1, current + 1);
      if (start > 2) pages.push('gap');
      for (var p = start; p <= end; p++) pages.push(p);
      if (end < total - 1) pages.push('gap');
      pages.push(total);
      return pages;
    }

    function render(root, page, scroll) {
      var panel = activePanel(root);
      var pager = root.querySelector('[data-pl-pager]');
      if (!panel || !pager) return;
      var perPage = parseInt(root.getAttribute('data-pl-per-page'), 10) || 8;
      var items = panel.querySelectorAll('[data-pl-item]');
      var total = Math.ceil(items.length / perPage);
      page = Math.min(Math.max(1, page || 1), Math.max(1, total));
      panel.setAttribute('data-pl-page', page);

      items.forEach(function (item, i) {
        item.hidden = Math.floor(i / perPage) + 1 !== page;
      });

      if (total <= 1) {
        pager.hidden = true;
        pager.innerHTML = '';
        return;
      }

      var labelPage = pager.getAttribute('data-label-page') || 'Page';
      var html = '<button type="button" class="pl-pager__btn" data-pl-page="' + (page - 1) + '" aria-label="' + pager.getAttribute('data-label-prev') + '"' + (page === 1 ? ' disabled' : '') + '>' + ARROW_L + '</button>';
      pageList(page, total).forEach(function (p) {
        if (p === 'gap') {
          html += '<span class="pl-pager__gap" aria-hidden="true">…</span>';
        } else {
          html += '<button type="button" class="pl-pager__btn" data-pl-page="' + p + '" aria-label="' + labelPage + ' ' + p + '"' + (p === page ? ' aria-current="page"' : '') + '>' + p + '</button>';
        }
      });
      html += '<button type="button" class="pl-pager__btn" data-pl-page="' + (page + 1) + '" aria-label="' + pager.getAttribute('data-label-next') + '"' + (page === total ? ' disabled' : '') + '>' + ARROW_R + '</button>';
      pager.innerHTML = html;
      pager.hidden = false;

      if (scroll) {
        var top = root.getBoundingClientRect().top + window.scrollY - 120;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    function init(scope) {
      (scope || document).querySelectorAll('.pl-packs').forEach(function (root) {
        var panel = activePanel(root);
        render(root, panel ? parseInt(panel.getAttribute('data-pl-page'), 10) || 1 : 1, false);
      });
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var tab = event.target.closest('.pl-packs [data-pl-tab]');
      if (tab) {
        var root = tab.closest('.pl-packs');
        var id = tab.getAttribute('data-pl-tab');
        root.querySelectorAll('[data-pl-tab]').forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('pl-chip--active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-pl-panel]').forEach(function (p) {
          p.hidden = p.getAttribute('data-pl-panel') !== id;
        });
        var viewAll = root.querySelector('.pl-packs__head a');
        var url = tab.getAttribute('data-pl-url');
        if (viewAll && url) viewAll.setAttribute('href', url);
        render(root, 1, false);
        return;
      }

      var btn = event.target.closest('.pl-packs [data-pl-pager] [data-pl-page]');
      if (btn && !btn.disabled) {
        render(btn.closest('.pl-packs'), parseInt(btn.getAttribute('data-pl-page'), 10), true);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
